import { render } from "./ShowProductDetails.vue?vue&type=template&id=59d7c01b&scoped=true"
import script from "./ShowProductDetails.vue?vue&type=script&lang=js"
export * from "./ShowProductDetails.vue?vue&type=script&lang=js"

import "./ShowProductDetails.vue?vue&type=style&index=0&id=59d7c01b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d7c01b"]])

export default __exports__